var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkImageDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.4541L13.75 8.9541",
    stroke: "#9C3DE7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0859 6.20373L10.5104 5.7124C11.37 4.85286 12.5359 4.37003 13.7516 4.37012C14.9672 4.3702 16.133 4.8532 16.9926 5.71286C17.8521 6.57251 18.3349 7.7384 18.3348 8.95405C18.3348 10.1697 17.8518 11.3355 16.9921 12.1951L16.5026 12.6204",
    stroke: "#9C3DE7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9142 17.2038L11.5503 17.6933C10.6806 18.5533 9.50683 19.0356 8.28373 19.0356C7.06064 19.0356 5.88688 18.5533 5.01719 17.6933C4.58852 17.2694 4.2482 16.7647 4.01593 16.2084C3.78366 15.6521 3.66406 15.0552 3.66406 14.4524C3.66406 13.8496 3.78366 13.2527 4.01593 12.6964C4.2482 12.1401 4.58852 11.6354 5.01719 11.2115L5.49753 10.7871",
    stroke: "#9C3DE7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkImageDark);
export default __webpack_public_path__ + "static/media/linkImageDark.38f3c264d0c9c5d58765355aa0a5bfe6.svg";
export { ForwardRef as ReactComponent };